import { ACTIONS_TEAM } from "../actions/team-batters";

const headerBatters = [
    {
        name: '背番号',
        name_s: 'uniform_number'
    },{
        name: '選手',
        name_s: 'player_name'
    },{
        name: '試合',
        name_s: 'g'
    },{
        name: '打席',
        name_s: 'pa'
    },{
        name: '打数',
        name_s: 'ab'
    },{
        name: '得点',
        name_s: 'r'
    },{
        name: '安打',
        name_s: 'h'
    },{
        name: '二塁打',
        name_s: 'h2b'
    },{
        name: '三塁打',
        name_s: 'h3b'
    },{
        name: '本塁打',
        name_s: 'hr'
    },{
        name: '塁打',
        name_s: 'tb'
    },{
        name: '打点',
        name_s: 'rbi'
    },{
        name: '三振',
        name_s: 'so'
    },{
        name: '四球',
        name_s: 'bb'
    },{
        name: '敬遠',
        name_s: 'ibb'
    },{
        name: '死球',
        name_s: 'hbp'
    },{
        name: '犠打',
        name_s: 'sh'
    },{
        name: '犠飛',
        name_s: 'sf'
    },{
        name: '盗塁',
        name_s: 'sb'
    },{
        name: '盗塁刺',
        name_s: 'cs'
    },{
        name: '併殺打',
        name_s: 'gidp'
    },{
        name: '失策',
        name_s: 'e'
    },{
        name: '打率',
        name_s: 'avg'
    },{
        name: '長打率',
        name_s: 'slg'
    },{
        name: '出塁率',
        name_s: 'obp'
    },{
        name: 'OPS',
        name_s: 'ops'
    },{
        name: '1軍復帰',
        name_s: 'comback_date'
    }
];

export default (state = {
    headerBatters
}, action) => {
    switch (action.type) {
        case ACTIONS_TEAM.GET_INFO_BATTERS_GAMES_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data.data,
                default_sort: action.data.default_sort
            };
        case ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};
